import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { base_url } from "./AdminUsers";


const SettleHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchPhone, setSearchPhone] = useState("");
  const [settlements, setSettlements] = useState([]);
  const [filteredSettlements, setFilteredSettlements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [history, setHistory] = useState([]); // Store navigation history
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const FetchUserData = async () => {
    try {
      setLoading(true);
      const auth = localStorage.getItem("admin");

      const response = await axios.get(`${base_url}/api/admin/getSettleHistory`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${auth}`,
        },
        params: {
          fromDate: fromDate || undefined,
          toDate: toDate || undefined,

        },
      });

      //   console.log("Response is all settlemet ", response)

      const data = response.data.data || [];

      setSettlements(data);
      setFilteredSettlements(data);
      setError("");
    } catch (error) {
      console.error("Error fetching settlements:", error);
      setError("Failed to fetch settlement data.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();
    // Reset history when applying new filters
    setHistory([]);
    FetchUserData();
  };

  useEffect(() => {
    FetchUserData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchPhone(value);

    const filtered = settlements.filter((item) =>
      item.phone?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSettlements(filtered);
  };


  return (
    <div className="wrapper">
      {/* <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      /> */}

      {/* Content Wrapper - Use conditional class and margin */}
      <div
        className={`content-wrapper ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
        }}
      >
        {/* <section className="content-header">
  <div className="container-fluid">
    <div className="row mb-3">
      <div className="col">
        <h1 className="bg-dark text-white py-3 px-4 rounded shadow-sm d-inline-block">
          Settlement
        </h1>
      </div>
    </div>
  </div>
</section> */}

        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* Header Card */}
              <div
                className="bg-gradient p-3 rounded shadow mb-4"
                style={{
                  background: "linear-gradient(to right, #00c6ff, #0072ff)",
                  color: "black",
                }}
              >
                <h4 className="mb-0">
                  <i className="fas fa-coins me-2"></i>Settlement History
                </h4>
              </div>

              {/* Filter Card */}
              <div className="bg-white p-4 rounded shadow-sm mb-4 border border-light-subtle">
                <div className="row gy-3 gx-4 align-items-end">
                  <div className="col-sm-6 col-md-3">
                    <label htmlFor="fromDate" className="form-label">
                      <i className="fas fa-calendar-alt me-2 text-primary"></i>
                      From Date
                    </label>
                    <input
                      type="date"
                      id="fromDate"
                      className="form-control shadow-sm"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-6 col-md-3">
                    <label htmlFor="toDate" className="form-label">
                      <i className="fas fa-calendar-alt me-2 text-danger"></i>To
                      Date
                    </label>
                    <input
                      type="date"
                      id="toDate"
                      className="form-control shadow-sm"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                    />
                  </div>

                  <div className="col-sm-6 col-md-2">
                    <button
                      className="btn btn-success w-100 shadow-sm"
                      onClick={handleFilter}
                    >
                      <i className="fas fa-filter me-2"></i>Filter
                    </button>
                  </div>

                  <div className="col-sm-6 col-md-4">
                    <label htmlFor="searchPhone" className="form-label">
                      <i className="fas fa-search me-2 text-muted"></i>Search
                      username
                    </label>
                    <input
                      type="text"
                      id="searchPhone"
                      className="form-control shadow-sm"
                      placeholder="Enter user name"
                      value={searchPhone}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>
              </div>
  

              {/* Settlement Table */}
              <div className="table-responsive shadow rounded">
                <table className="table table-bordered table-hover align-middle text-center">
                  <thead className="table-dark">
                    <tr>
                      <th>S No.</th>
                      <th>User Name</th>
                      <th>Role</th>
                      <th>Previous Balance</th>
                      <th>Settlement Amount</th>
                      <th>New Balance</th>
                      <th>Total Profit</th>
                      <th>Total Loss</th>
                      <th>Settlement Type</th>
                      <th>Settled By</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="13">Loading...</td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="13" className="text-danger">
                          {error}
                        </td>
                      </tr>
                    ) : filteredSettlements.length > 0 ? (
                      filteredSettlements.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.phone}</td>
                          <td>
                            <span className="badge bg-info">{item.role}</span>
                          </td>
                          <td>
                            {parseFloat(item.previous_balance || 0).toFixed(2)}
                          </td>
                          <td>
                            
                            {parseFloat(item.settlement_amount || 0).toFixed(2)}
                          </td>
                          <td>
                            {parseFloat(item.new_balance || 0).toFixed(2)}
                          </td>
                          <td className="text-success">
                            {parseFloat(item.total_profit || 0).toFixed(2)}
                          </td>
                          <td className="text-danger">
                            {parseFloat(item.total_loss || 0).toFixed(2)}
                          </td>
                          <td>{item.settlement_type}</td>
                          <td>{item.settled_by}</td>
                          <td>{item.settlement_date}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="13">No settlements found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettleHistory;